import { Badge } from '@components/primitives';

import { TeamObject } from '@api/types';
import { labelForPlan } from '@components/features/Settings/TeamBilling/utils';

import css from './styles.module.css';

interface TierBadgeProps {
  team: TeamObject | undefined;
}
export function TierBadge({ team }: TierBadgeProps) {
  if (!team) return null;

  const label = labelForPlan(team.tier);

  if (team.tier === 'pro') {
    return (
      <Badge size="sm" variant="primary" className={css.tierBadge}>
        {label}
      </Badge>
    );
  } else if (team.tier === 'enterprise') {
    return (
      <Badge size="sm" variant="warning" className={css.tierBadge}>
        {label}
      </Badge>
    );
  } else if (team.tier === 'legacy') {
    return (
      <Badge size="sm" variant="success" className={css.tierBadge}>
        {label}
      </Badge>
    );
  } else {
    return (
      <Badge size="sm" variant="outline" className={css.tierBadge}>
        {label}
      </Badge>
    );
  }
}
